import Contact from '../Contact-screen/Contact.js';
import Footer from '../../Utils/Footer/footer-component'
import Layout from '../../Utils/Navbar/navbar-layout-component.js';
import LocationsSection from './LocationsSection.js';
import LocationsHeroSection from './Locations-Hero-Section.js';
import QuickCallSection from '../../Utils/Sections/section-quick-call-component.js';


function LocationsScreen() {

    return (
        <div className="flex w-full flex-col">
            <div>
                <Layout>
                    <LocationsSection
                        title="Explore Our Service Areas"
                        isLearnMore={true}
                    />
                    <QuickCallSection/>
                    <Contact />
                </Layout>
                <Footer />
            </div>

        </div>
    );
}

export default LocationsScreen;